export const AllProjects = [

    {
        id: 1,
        title: 'Creative-Agency',
        image: 'https://i.ibb.co/pjyLWrw/screencapture-creative-agency-f6271-web-app-2020-11-23-11-07-55.jpg',
        discription: 'A full-stack responsive service selling web app. Thats also multipage. This app has a user dashboard and also have an admin dashboard.',
        features: ['☛ People can select and order a service',
            '☛ People can see his / her ordered services and services are pending / ongoing / done.',
            ' ☛ People also able to give his / her review and the review also show on the website.',
            ' ☛ Admin can add a service and also delete a service and added service also show on the website.',
            ' ☛ Admin can see All ordered services and able to change services is pending / ongoing / done.',
            '  ☛ Admin also adds other Admin.',],
        technologies: ['React.js', 'Rest Api', 'React Router', 'Nodejs', 'Express.js', 'MongoDB', 'React Hook Form', 'React Bootstrap', 'Heroku', 'Firebase', 'HTML', 'CSS',],
        liveLink: 'https://creative-agency-f6271.web.app/',
        frontendLink: 'https://github.com/moshiuzzaman/creative-agency-client-site',
        backendLink: 'https://github.com/moshiuzzaman/creative-agency-server-site'
    },
    {
        id: 2,
        title: 'Doctors Portal',
        image: 'https://i.ibb.co/Rjbxhw4/screencapture-fir-practice-f0ef9-web-app-2020-11-23-11-08-41.jpg',
        discription: 'A full-stack responsive Doctors appointment booking web app. Thats also a multipage app whereyou can pick the date and time and fix an appointment with a doctor.',
        features: ['☛ Patients can pick a date and time and get an appointment.',
            '☛ Patients can see his / her prescription.',
            ' ☛ The doctor can review all patients who already get an appointment and also add a prescription.'],
        technologies: ['React.js', 'Rest Api', 'React Router', 'Nodejs', 'Express.js', 'MongoDB', 'React Hook Form', 'React Bootstrap', 'Heroku', 'Firebase', 'HTML', 'CSS',],
        liveLink: 'https://fir-practice-f0ef9.web.app/',
        frontendLink: 'https://github.com/moshiuzzaman/doctors-portal-client-side',
        backendLink: 'https://github.com/moshiuzzaman/doctors-portal-server-side'
    },
    {
        id: 3,
        title: 'Power-X-Gym',
        image: 'https://i.ibb.co/n1bShJB/powerx-1-1.jpg',
        discription: 'It is a group project.Power-X-Gym is a body fitness website. There anyone can join a fitness class and he/she pays from his credit card in this class payment',
        features: ['☛ People select a date and place at a time.',
            ' ☛ People select a place by using Google map.',
            ' ☛ Hotel booking system by selecting a place',],
        technologies: ['React.js', 'React Router', 'Node.js', 'Express.js', 'React Hook Form',  'Stripe Payment system', 'Rest Api', 'Mongo DB', 'Hiroku','Bootstrap', 'HTML', 'SCSS', ],
        liveLink: 'https://powerxgym-68ed9.web.app/',
        frontendLink: 'https://github.com/PowerXgym/powerx-gym',
    },
    {
        id: 4,
        title: 'Travel guru',
        image: 'https://i.ibb.co/TvhvbP2/project-1.jpg ',
        discription: 'A Travel Agency responsive website. There any people who pick the date and book his / her interesting place where can want to go.',
        features: ['☛ People select a date and place at a time.',
            ' ☛ People select a place by using Google map.',
            ' ☛ Hotel booking system by selecting a place',],
            technologies: ['React.js', 'Google map', 'React Router', 'Node.js', 'Express.js', 'Mongo DB', 'HTML', 'CSS', 'Bootstrap',],
        liveLink: 'https://travel-guru-assainment.web.app/',
        frontendLink: 'https://github.com/moshiuzzaman/travel-guru',
    },
    {
        id: 5,
        title: 'Athena-Design',
        image: 'https://i.ibb.co/L6QYwNJ/Web-1.jpg ',
        discription: 'It is a group project. Athena Design is a website for  provide services.Here we provide some services to our clients with our three types of price.        ',
        features: ['☛ People select a date and place at a time.',
            ' ☛ People select a place by using Google map.',
            ' ☛ Hotel booking system by selecting a place',],
         technologies: ['React.js',  'React Router','Bootstrap', 'HTML', 'CSS', ],
        liveLink: 'https://athena-design-agency.netlify.app/        ',
        frontendLink: 'https://github.com/moshiuzzaman/athena-design-agency',
    },
    {
        id: 6,
        title: 'Car-Shop',
        image: 'https://i.ibb.co/923ZBwn/car-shop.jpg',
        discription: 'Car shop is a car review web app , this app has so many feature, like anyone can review a car , user can search a car by brand name, user can add a car and if he want he also delete this car',
        features: ['☛ People select a date and place at a time.',
            ' ☛ People select a place by using Google map.',
            ' ☛ Hotel booking system by selecting a place',],
         technologies: ['React.js', 'React Router',  ' React-Bootstrap','Node.js', 'Express.js', 'Mongo DB', 'HTML', 'CSS'],
        liveLink: 'https://car-shop-4427f.web.app/',
        frontendLink: 'https://github.com/moshiuzzaman/car-shop.git',
    },
     {
        id:7,
        title: 'Redux-shop',
        image: 'https://i.ibb.co/Lhyr5Wk/react-cart.jpg',
        discription: 'This is a shop web app, this app have so many features',
        features: ['☛ People select a date and place at a time.',
            ' ☛ People select a place by using Google map.',
            ' ☛ Hotel booking system by selecting a place',],
         technologies: ['React.js', 'React Router','React reveal ' ,' React-Bootstrap','Node.js', 'Express.js', 'Mongo DB', 'HTML', 'CSS'],
        liveLink: 'https://redux-shop-new.netlify.app/',
        frontendLink: 'https://github.com/moshiuzzaman/react-shopping-cart.git',
    },
    
]